// extracted by mini-css-extract-plugin
export var bodySections = "_4m-8";
export var gray = "_4m-7";
export var green = "_4m-4";
export var iconContainer = "_4m-9";
export var iconWidgetContainer = "_4m-1";
export var phoneIcon = "_4m-2";
export var red = "_4m-5";
export var statusDot = "_4m-3";
export var widgetContainer = "_4m-0";
export var yellow = "_4m-6";